import * as StyledResources from "../Styled.Resources";

const LogoHosting = (props) => {
  return (
    <StyledResources.LogoVendors
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      xmlSpace="preserve"
      style={{
        fillRule: "evenodd",
        clipRule: "evenodd",
        strokeLinejoin: "round",
        strokeMiterlimit: 2,
      }}
      viewBox="0 0 48 48"
      {...props}
    >
      <defs>
        <mask id="a">
          <image
            xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAAAAAByaaZbAAAACXBIWXMAAA7EAAAOxAGVKw4bAAACcUlEQVRIia2UXUhTYRzGn525VW5MiLkF06SSNSQh7MIQkT6gknB005cEQTdFCIUFdVWB11F0Y91UJBEWBZGGCAumCEEEBSLT2oWZLWgGLhxb287TxTlnO1/u3UXP1XnO+T3v1/89f+C/SIpcmsmsPNlVK9/wPEOSTHfUhDujs1SV3FwD775V0ngWD9Uw/ojMiu4I+cBL6jUlDLw18FwU4BtHjDzT1fm66yVT4Hv1wEDRxDNRlQ//NPMcs0BS5bEhHrR8nq8WuGnl8bnKgo7JlgUxv3d9vn7WyjPTbOHqtIerbTajLKWcPSfD+Yl7tHzqsBmfHGwek0nyrmQJvLLjc/0/1L2EzXy3pWQkWdTOQT5l2oP7gdPuIMovHa3ld8riOnfY8To1GgOuoQ2CQNYYONwj4LFqDJxxCHh+MQRcB0QTyMuGwOXG9VFFRcOv6vtjW2W93ldoCdjtEU2A24ZAl2jLSL02BKLCCWJ/9a7F9hoZdBQAHCfGn/kA4IKQ/+ACEJkkuewH8FTEF7oARFZJkr2Q3JarbtbcJ6DpjQ8A0AjJ4xfwuStZOIfV+y0DW9KCFQ0D6NVa6BEglKnOr7UC/hXNbQda8ibi26Te5fsAnNVcwgFsMzXs3J6Y3j6UAIyrRt4HYGvOwKf2Y0FnZ3wAvFnVfXQACP7S84VuIFGxv0MA0KfZcwDgndPxi50A4mX7dScA4JpqR5UW86jCxwMAcF+z8+3K4d9QbDKk2KB2rrnBegDAwYLipwJq6Y6TJJeatFJGMyS59lhr7Z4XJJkccGmAd4EsvWuvFH/TUGziok93G85Pj/brb0dbfPq0tR3XqH/XwSCy27ZkYwAAAABJRU5ErkJggg=="
            width={48}
            height={48}
          />
        </mask>
      </defs>
      <g mask="url(#a)">
        <ellipse
          cx={110.62}
          cy={93.354}
          rx={269.291}
          ry={153.87}
          transform="rotate(129.795 34.283 29.516) scale(.30882)"
        />
      </g>
    </StyledResources.LogoVendors>
  );
};
export default LogoHosting;
